import { GenericDateFilterFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const DeviceLogsDateFilterStore = GenericDateFilterFactory(GENERIC_IDS.DEVICE_LOGS);